export const isInt = (n: number) => {
    return n % 1 < 0.1
}
